import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Actions, AppState, IPageState, store } from '../../appredux';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import Typography from '@material-ui/core/Typography';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Link } from '@material-ui/core';
import { Doladowania, Doladuj, KarnetDoladowania, KarnetLogo, KarnetService, payServicePrzelewy24, Przelewy24Status, Result, vscPaymentPrzelewy24 } from 'api';
import CONFIG from 'cfg/config';
import LoaderNoWindow from 'components/LoaderNoWindow';
import Loader from 'components/Loader';
import { sendErrorLog } from 'common/helpers';
import { TransProps, WithTranslation, withTranslation } from 'react-i18next';
import MuiCheckbox from 'components/MuiCheckbox';



interface DialogProps extends WithStyles<typeof styles> {
    page: IPageState,
    platnosc: Doladowania,
    dokNr: string,
}

interface DialogState {
    open: boolean
    loading: boolean,
    dokNr: string,
    status: string,
    lastStatus: string,
    timeStart: number,
    timeMinutes: number,
}

class DialogUkryjPracownika extends React.Component<WithTranslation & TransProps & DialogProps, DialogState>  {

    constructor(props: WithTranslation & TransProps & DialogProps) {
        super(props, {});
        this.state = {
            open: true,
            loading: true,
            dokNr: this.props.dokNr,
            status: "-2",
            lastStatus: "-2",
            timeStart: new Date().getTime(),
            timeMinutes: 1,
        }
    }


    interval: any;
    logInterval: any;
    timeout: any;

    async componentDidMount() {
      this.setPaymentInterval()
      sendErrorLog("1", "1", `zamknieto strone przy platnosci ${this.state.dokNr}`)
      store.dispatch(Actions.pageState.addFcmLogMessage(`zamknieto strone przy platnosci ${this.state.dokNr}`, 0))
    }

    componentDidUpdate(prevProps: DialogProps) {
    }

    closeDialog = () => {
        this.setState({open: false})
    }

 

      

      setPaymentInterval = async () => {
        await this.paymentState(this.state.dokNr);
        this.setState({loading: false})

        if(this.state.status !== "2"){

            this.interval = setInterval(() => {
                this.paymentState(this.state.dokNr);
              }, 10000); // 10s
              this.logInterval = setInterval(() => {
                this.logCount();
              }, 60000); // 60s

          this.timeout = setTimeout(() => {
            //if(this.state.isFailure){
            sendErrorLog("1", "1", `minelo 15min od rozpoczecia transakcji, anulacja ${this.state.dokNr}`)
            store.dispatch(Actions.pageState.addFcmLogMessage(`minelo 15min od rozpoczecia transakcji, anulacja ${this.state.dokNr}`, 0))
            this.anuluj();
            this.setState({ ...this.state, status: "error" });
            //}  
            clearInterval(this.interval);
            clearInterval(this.logInterval);
            clearTimeout(this.timeout);
          }, 900000); //15 min

        }

      }



      async paymentState(id: string) {
        //console.log("status")
        try {
    
    
         //Przelewy24
    
              let res2: Przelewy24Status = await payServicePrzelewy24.getStatusPrzelewy24({ hotelId: CONFIG.hotelId, vscNr: Number(id), prefiks: CONFIG.karnetPayWebPrefiks, kontoId: CONFIG.karnetPayWebKontoId })
              //console.log(res2)
              if (!res2 || !res2.data){
                this.setState({ status: 'error' })
              } else if (res2 && res2.data.status === 0) {
                this.setState({ status: '0' })   
                
                if(this.state.status !== this.state.lastStatus){
                  this.setState({ lastStatus: '0' })
                  sendErrorLog("1", "1", `platnosc: pl.com.virtualsc:vscSmartSki:war:1.0.0, status: 0, czas: ${this.timeDifference()}`)
                  store.dispatch(Actions.pageState.addFcmLogMessage(`platnosc: pl.com.virtualsc:vscSmartSki:war:1.0.0, status: 0, czas: ${this.timeDifference()}`, 0))
                }
    
              }else if (res2 && res2.data.status === 1) {
                this.setState({ status: '1' }) 
    
                if(this.state.lastStatus !== '1' ){
                  this.setState({ lastStatus: '1' })
                  sendErrorLog("1", "1", `platnosc: pl.com.virtualsc:vscSmartSki:war:1.0.0, status: 1, czas: ${this.timeDifference()}`)
                  store.dispatch(Actions.pageState.addFcmLogMessage(`platnosc: pl.com.virtualsc:vscSmartSki:war:1.0.0, status: 1, czas: ${this.timeDifference()}`, 0))
                }
    
            
              } else if(res2 && res2.data.status === 2){
                this.setState({ status: '2'})//, isFailure: false })
    
                if(this.state.lastStatus !== '2'){
                  this.setState({ lastStatus: '2' })
                  sendErrorLog("1", "1", `platnosc: pl.com.virtualsc:vscSmartSki:war:1.0.0, status: 2, czas: ${this.timeDifference()}`)
                  store.dispatch(Actions.pageState.addFcmLogMessage(`platnosc: pl.com.virtualsc:vscSmartSki:war:1.0.0, status: 2, czas: ${this.timeDifference()}`, 0))
                }
    
                clearInterval(this.interval);
                clearInterval(this.logInterval);
                clearTimeout(this.timeout);
                
                this.potwierdz()
    
              }
             
            
    
        } catch (error) {
          await sendErrorLog("0", "-1", 'pobranie stanu platnosci')
          await store.dispatch(Actions.pageState.addFcmLogMessage("pobranie stanu platnosci", 2))
          console.log(error)
        }
      }

      potwierdz = async () => {
        try {
          this.setState({loading: true})
          let res: Result<number> = await Doladuj.dajKarnetPotwierdz({
             parametry: { 
              dokNr: this.state.dokNr,
              hotelId: CONFIG.hotelId, 
              jakRozliczac: this.props.platnosc.jakRozliczac,
              karnetEkarta: this.props.page.karnet.ekarta, 
              karnetId: this.props.page.karnet.ekartaId,
              karnetLogo: this.props.page.karnet.logo,
              karnetTyp: "00",
              kwota: this.props.platnosc.kwota,
              operatorId: "1", 
              wplataId: this.props.platnosc.wplataId,
              wplataTyp: this.props.platnosc.wplataTyp,
              wplataWwwOpis: this.props.platnosc.wwwOpis,
              upust: this.props.platnosc.upust
            }
             })
          this.setState({loading: false})

          ////
          localStorage.removeItem("platnosc")
          ////

          let resKarnet: Result<KarnetLogo> = await KarnetService.dajKarnet({ parametry: { hotelId: CONFIG.hotelId, karnetLogo: CONFIG.karnetLogo, operatorId: "1" } })
          if (resKarnet.result.length > 0) {
            store.dispatch(Actions.pageState.setKarnet(resKarnet.result[0]))
          }
          store.dispatch(Actions.pageState.setTimer())

          
          let resTabelaDoladowania: Result<KarnetDoladowania> = await KarnetService.dajKarnetDoladowania({ parametry: { hotelId: CONFIG.hotelId, operatorId: "1", karnetEkarta: this.props.page.karnet.ekarta } })
            await store.dispatch(Actions.pageState.setKarnetDoladowania(resTabelaDoladowania.result))
            
              

          sendErrorLog("1", "1", `potwierdzenie karnetu ${this.state.dokNr}`)
          store.dispatch(Actions.pageState.addFcmLogMessage(`potwierdzenie karnetu ${this.state.dokNr}`, 0))
          //console.log(res)
        } catch (error) {
          console.error()
          this.setState({status: "error"})
          sendErrorLog("0", "-1", '/karnet/karnetPotwierdz')
          store.dispatch(Actions.pageState.addFcmLogMessage("/karnet/karnetPotwierdz", 2))
        }
      }

      anuluj = async () => {
        try {
          this.setState({loading: true})
          let res: Result<number> = await Doladuj.dajKarnetAnuluj({
             parametry: { 
              dokNr: this.state.dokNr,  
              hotelId: CONFIG.hotelId, 
              jakRozliczac: this.props.platnosc.jakRozliczac, 
              karnetEkarta: this.props.page.karnet.ekarta, 
              karnetId: this.props.page.karnet.ekartaId,
              karnetLogo: this.props.page.karnet.logo,
              karnetTyp: "00",
              kwota: this.props.platnosc.kwota,
              operatorId: "1", 
              wplataId: this.props.platnosc.wplataId,
              wplataTyp: this.props.platnosc.wplataTyp,
              wplataWwwOpis: this.props.platnosc.wwwOpis,
              upust: this.props.platnosc.upust
            }
             })
          this.setState({loading: false})
          store.dispatch(Actions.pageState.setTimer())
          sendErrorLog("1", "1", `anulowanie karnetu ${this.state.dokNr}`)
          store.dispatch(Actions.pageState.addFcmLogMessage(`anulowanie karnetu ${this.state.dokNr}`, 0))
          //console.log(res)
        } catch (error) {
          console.error()
          this.setState({status: "error"})
          sendErrorLog("0", "-1", '/karnet/karnetAnuluj')
          store.dispatch(Actions.pageState.addFcmLogMessage("/karnet/karnetAnuluj", 2))
        }
      }


      timeDifference = () : string => {
        let date = new Date(new Date().getTime() - this.state.timeStart) ;
        let min = date.getUTCMinutes();
        let sec = date.getUTCSeconds();
        let ss = sec <= 9 && sec >= 0 ? `0${sec}` : sec;
        let mm = min <= 9 && min >= 0 ? `0${min}` : min;
        return mm + ":" + ss;
      }

      logCount = () => {
        sendErrorLog("1", "1", `minelo ${this.state.timeMinutes}min od rozpoczecia transakcji`)
        store.dispatch(Actions.pageState.addFcmLogMessage(`minelo ${this.state.timeMinutes}min od rozpoczecia transakcji`, 0))   
        this.setState({timeMinutes: this.state.timeMinutes + 1}) 
      }


      statusOpis = (status: string, t: any): string[] => {
        let opis: string[] = [];
    
        
    
          switch (status) {
            case 'PreStart':
              opis[0] = t('Payment has started1');
              opis[1] = t('Details new window1');
              opis[2] = t('Ask open1');
              opis[3] = t( 'Click link1 mBank');
              opis[10] = t('Payment has started2');
              opis[11] = t('Details new window2');
              opis[12] = t('Ask open2');
              opis[13] = t('Click link2');
              break;
            case '0':
              opis[0] = t('Payment has started1');
              opis[1] = t('Details new window1');
              opis[2] = t('Ask open1');
              opis[3] = t( 'Click link1 mBank');
              opis[10] = t('Payment has started2');
              opis[11] = t('Details new window2');
              opis[12] = t('Ask open2');
              opis[13] = t('Click link2');
              break;
            case '1': 
              opis[0] = t('Payment has started');
              opis[1] = t('The customer has not yet made a payment');
              break;  
            case 'PositiveAuthorization': 
              opis[0] = t('The transaction was initially positively authorized by the payment operator');
              opis[1] = t('Its final status will be determined at a later date');
              break;
          }
    
      
    
    
        return opis;
      }


    render() {
        const {classes, t} = this.props;
        const wciecie: string = '   * ';

        const statusOpis = this.statusOpis(this.state.status, t);
        let status = this.state.status
        let tytul = status === "-1" ? "potwierdzenie" : status === "2" ? "sukces" : status === "error" ? "niepowodzenie" : "płatność on-line"
       
        let tablet = this.props.page.tablet


        
        return (
            <>
                { this.state.loading ? <Loader/> : null}
                {this.state.status !== "-2" ? 
                <Dialog
                    maxWidth="xs"
                    open={this.state.open}
                    //onEscapeKeyDown={this.props.closeDialog}
                    //onBackdropClick={this.props.closeDialog}
                    style={{zoom: tablet? "1.2" : "1"}}
                    fullWidth
                >
                    <DialogTitle disableTypography >
                        <Typography gutterBottom variant="h6" component="h2" color={this.state.status === "error" ? "error" : "primary"}
                            className={`${classes.headline}`}><b style={{ }}>{tytul}</b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle>
                    <DialogContent>

                      {this.state.status === "-1" ?
                        <>
                        </>
                        : this.state.status === "error" ? 
                        <>
                        <DialogContentText className={`${classes.dialogContentText} ${classes.gray}`} style={{color: "#555"}}>
                            {"Nie doładowano karnetu"}
                        </DialogContentText> 
                        <DialogContentText className={`${classes.dialogContentText} ${classes.gray}`} style={{color: "#555"}}>
                            {""}
                        </DialogContentText> 
                         <DialogContentText className={`${classes.dialogContentText} ${classes.gray}`} style={{color: "#555"}}>
                          {wciecie}{"spróbuj jeszcze raz"}
                        </DialogContentText>  
                        <DialogContentText className={`${classes.dialogContentText} ${classes.gray}`} style={{color: "#555"}}>
                          {wciecie}{"lub prosimy o kontakt telefoniczny"}
                        </DialogContentText> 
                        </>
                        : this.state.status === "2" ? 
                        <>
                        <DialogContentText className={`${classes.dialogContentText}`} >
                            {"Doładowano karnet"}
                        </DialogContentText>  
                         <DialogContentText className={`${classes.dialogContentText}`} >
                         {wciecie}{"twój karnet "}<b className={classes.primary} >{CONFIG.karnetLogo}</b>
                        </DialogContentText>  
                        <DialogContentText className={`${classes.dialogContentText}`} >
                          {wciecie}{"wybrano "}<b className={classes.primary} >{this.props.platnosc.wwwOpis}</b>
                        </DialogContentText> 
                        </>
                        :
                        <Fragment>
                          <DialogContentText className={`${classes.dialogContentText}`}>
                            Info <b color="pr"></b>
                          </DialogContentText>
                          <DialogContentText className={`${classes.dialogContentText}`}>
                            {statusOpis[10] ? <p>{wciecie}<b className={classes.primary}>{statusOpis[0]}</b> {statusOpis[10]}</p> : wciecie + statusOpis[0]}
                          </DialogContentText>
                          <DialogContentText className={`${classes.dialogContentText}`}>
                            {statusOpis[11] ? <p>{wciecie}<b className={classes.primary}>{statusOpis[1]}</b> {statusOpis[11]}</p> : wciecie + statusOpis[1]}
                          </DialogContentText>
                          {statusOpis[2] ? <DialogContentText className={`${classes.dialogContentText}`}>
                            {statusOpis[12] ? <p>{wciecie}<b className={classes.primary}>{statusOpis[2]}</b> {statusOpis[12]}</p> : wciecie + statusOpis[2]}
                          </DialogContentText> : null}
                          {/* {statusOpis[3] ? <DialogContentText className={`${classes.dialogContentText}`}>
                            {statusOpis[13] ? <p>{wciecie}<Link color='error' href={this.state.linkPlatnosci} target='_blank' ><b>{statusOpis[3]} {statusOpis[13]}</b></Link></p> : wciecie + statusOpis[3]}
                          </DialogContentText> : null} */}
                        </Fragment>
                        }


                    </DialogContent>
                    <DialogActions>
                      {this.state.status === "-1" || this.state.status === "2" || this.state.status === "error"?
                      <>
                        <Button variant="outlined" color={this.state.status === "error" ? "secondary" : "primary"} size="small" className={classes.button}
                            onClick={this.closeDialog}>
                            <b>wróć</b>
                        </Button>
                      
                      </> : null
                      }
                       
                    </DialogActions>
                </Dialog>
                : null }
            </>

        );
    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      secondary: {
        color: theme.palette.secondary.main
      },
      error: {
          color: "rgb(244, 67, 54)"
      }, 
      gray: {
        color: theme.palette.text.secondary,
      },
      paddingBottom0: {
        paddingBottom: 0
      },
      paddingLeft: {
        paddingLeft: "15px"
      },
      headline: {
        lineHeight: "20px",
      },
      dialogContentText: {
        //color: theme.palette.text.secondary,
        color: theme.palette.primary.main,
        whiteSpace: "pre" as "pre",
        minHeight: "12px",
        marginBottom: '12px'
      },
      button: {
        textTransform: "none" as "none"
    },
    link: {
      cursor: "pointer",
      textDecoration: "none",
      color: "rgb(0, 128, 128)",
      //"&:hover":{
      //  color: "rgb(6, 92, 92)",
      //}
    },
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});


export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(DialogUkryjPracownika)));
